/* amaflow: Beim Hover ueber ein Muster zeigt die Kachel das Bild des
   zugehoerigen Geschwisterprodukts. Das Theme-JS kann das nicht, weil der
   Swatch-Renderer die Geschwisterbilder erst seit card_sibling_image ausgibt.
   Das zweite Produktbild beim Hover ueber das Bild macht weiterhin das Theme. */
(function () {
  function verdrahten(karte) {
    if (karte.dataset.amaflowKachel) return;
    var muster = karte.querySelectorAll('[data-sibling-image]');
    if (!muster.length) return;

    var bild = karte.querySelector('.product-card__image--main img');
    if (!bild) return;
    karte.dataset.amaflowKachel = '1';

    var original = bild.getAttribute('src');
    var originalSrcset = bild.getAttribute('srcset');

    function zeige(url) {
      if (!url) return;
      bild.removeAttribute('srcset');
      bild.src = url;
    }
    function zurueck() {
      if (original) bild.src = original;
      if (originalSrcset) bild.setAttribute('srcset', originalSrcset);
    }

    muster.forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        zeige(a.getAttribute('data-sibling-image'));
      });
    });

    var liste = karte.querySelector('ul.product-card__swatches');
    if (liste) liste.addEventListener('mouseleave', zurueck);
  }

  function alle() {
    document.querySelectorAll('.product-card').forEach(verdrahten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  /* Filter, Sortierung und "Mehr laden" tauschen das Raster aus - die neuen
     Kacheln muessen danach ebenfalls verdrahtet werden. */
  if (window.MutationObserver) {
    new MutationObserver(function () { alle(); }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
